import ApiService from '@/services/core/api.service'

const DealerService = {
  async get (query) {
    return ApiService.get(`admin/dealers?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/dealers', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/dealers/${payload.id}`, payload)
  }
}

export default DealerService
